import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import TransactionImportFilterAppResource from './TransactionImportFilterAppResource';
import ConnectorImportLogAppResource from './ConnectorImportLogAppResource';

export const IMPORT_TYPES = {
  USERS: 'users',
  TRANSACTIONS: 'transactions',
  LISTINGS: 'listings',
  CONTACTS: 'contacts',
  LOANS: 'loans',
};

export const CONNECTOR = {
  SKYSLOPE: 'a0e33f4d-2a8e-35a6-a6c3-c18d3a0d1d48',
};

class ConnectorImportAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'Connector-Import';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'connectors/imports';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'createdAt',
      'updatedAt',
      'importFilterUuid',
      'connectorType',
      'status',
      'importedObjectsCount',
      'exceptionsCount',
      'isFinished',
      'filters',
      'processedExternalUuids',
      'enabled',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      importFilter: TransactionImportFilterAppResource,
      imports: ConnectorImportLogAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return {
      importFilter: 'moxi_import_uuid',
      imports: 'import_uuid'
    };
  }

  /**
   * @returns {*}
   */
  validationRules() {
    // TODO: add validation rules
    return [];
  }

}

export default ConnectorImportAppResource;
